import styled from 'styled-components';
import tw from 'twin.macro';

import { Button } from '@nw/omega-design-system';

export const StyledButton = styled(Button)`
  ${tw`ring-0 ring-offset-0`}

  &:focus {
    ${tw`ring-0 ring-offset-0`}
  }
`;
